import { Tag } from "common/components/ui/Tag";

import {
  AUDIENCE_PROFILE_STATES,
  CANCELLED_TARGET_STATES,
} from "../../../../constants";

import type { AudienceProfileState, CancelledTarget } from "../../../../types";

interface AudienceStateTagProps {
  state: AudienceProfileState;
  cancellationDetails?: CancelledTarget;
  size: "sm" | "md";
}

export default function AudienceStateTag({
  state,
  cancellationDetails,
  size,
}: AudienceStateTagProps) {
  const { tagVariant, label } = AUDIENCE_PROFILE_STATES.find(({ states }) =>
    states.includes(state),
  );

  return (
    <Tag size={size} variant={tagVariant}>
      <span className="first-letter:capitalize">
        {cancellationDetails
          ? CANCELLED_TARGET_STATES[cancellationDetails.transition]
          : label}
      </span>
    </Tag>
  );
}
